<template>
    <div class="card">
        <h5>{{ $t('menu.cancelBets') }}</h5>
        <BetsOperations :operationType="'cancel'"></BetsOperations>
    </div>
</template>
<script>
import BetsOperations from './Components/BetsOperations.vue';
export default {
    name: 'cancelBets',
    components: {
        BetsOperations,
    },
    data() {
        return {};
    },
};
</script>